<template>
  <Layout :tituloPagina="'Sistema | Ajustes | Pasarelas pago | '+pasarela.nombre+ ' | Edición' ">
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <div class="card shadow-sm border">
          <div class="card-header justify-content-between d-flex align-items-center border-bottom py-3">
            <h4 class="card-title mb-0 font-size-15 fw-bold d-flex align-items-center">
              Editar pasarela de pago {{ pasarela.id != null ? '('+pasarela.nombre+')': '' }}
              <span class="badge bg-success ms-2 font-size-11" v-if="configuracion.activa">
                <i class="mdi mdi-circle me-1 font-size-10"></i>Activa
              </span>
              <span class="badge bg-secondary ms-2 font-size-11" v-else>
                <i class="mdi mdi-circle-outline me-1 font-size-10"></i>Inactiva
              </span>
            </h4>
            <div>
              <div class="dropdown">
                <a
                  class="dropdown-toggle"
                  href="javascript: void(0);"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <eva-icon
                    name="more-horizontal-outline"
                    data-eva-width="20"
                    data-eva-height="20"
                    :class="{
                      'fill-dark': $store.state.layout.layoutMode == 'light',
                      'fill-white': $store.state.layout.layoutMode == 'dark'
                    }"
                  ></eva-icon>
                </a>
                <ul class="dropdown-menu dropdown-menu-end shadow">
                  <li>
                    <a
                      href="#"
                      class="dropdown-item"
                      onclick="return false"
                      @click="guardar()"
                      v-if="!bandera_spinner"
                    >
                      <i class="mdi mdi-content-save text-success me-2"></i>
                      Actualizar
                    </a>
                    <span class="dropdown-item disabled" v-if="bandera_spinner">
                      <i class="mdi mdi-concourse-ci mdi-spin me-2"></i>
                      Actualizar
                    </span>
                  </li>
                  <li>
                    <a
                      class="dropdown-item" href="#"
                      onclick="return false;" @click="cerrar()"
                    >
                      <i class="mdi mdi-close text-dark me-2"></i>
                      Cerrar
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body p-4">
            <!-- Switches Row: Activa & Sandbox -->
            <div class="row g-3">
              <div class="col-md-6">
                <div class="d-flex align-items-center justify-content-between p-3 rounded bg-light border h-100">
                  <div>
                    <label class="font-size-13 fw-semibold mb-0">Pasarela Activa</label>
                    <div class="text-muted font-size-12">
                      {{ configuracion.activa ? 'Pasarela activa para procesar pagos' : 'Habilite para activar la pasarela' }}
                    </div>
                  </div>
                  <div class="form-check form-switch form-switch-lg mb-0">
                    <input
                      :checked="configuracion.activa"
                      @change="
                        configuracion.activa = !configuracion.activa,
                        mensajePasarelaActiva()
                      "
                      class="form-check-input style-pointer"
                      type="checkbox"
                      id="activarPasarela"
                    />
                    <label class="form-check-label" for="activarPasarela"></label>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex align-items-center justify-content-between p-3 rounded bg-light border h-100">
                  <div>
                    <label class="font-size-13 fw-semibold mb-0">Modo Prueba</label>
                    <div class="text-muted font-size-12">
                      {{ configuracion.sandbox ? 'Operaciones ficticias en Sandbox' : 'Transacciones reales en Producción' }}
                    </div>
                  </div>
                  <div class="form-check form-switch form-switch-lg mb-0">
                    <input
                      :checked="configuracion.sandbox"
                      @change="
                        configuracion.sandbox = !configuracion.sandbox,
                        mensajeModoPruebas()
                      "
                      class="form-check-input style-pointer"
                      type="checkbox"
                      id="sandbox"
                    />
                    <label class="form-check-label" for="sandbox"></label>
                  </div>
                </div>
              </div>
            </div>

            <hr style="margin-top: 1.25rem; margin-bottom: 1.25rem;">

            <!-- Credentials Section -->
            <div class="p-3 bg-light rounded border">
              <div class="row g-3">
                <div class="col-md-6">
                  <label class="fw-semibold font-size-13 mb-1 d-flex align-items-center justify-content-between">
                    <span>{{ tituloIdClient() }}</span>
                    <span
                      class="badge font-size-11"
                      :class="{
                        'bg-success': !configuracion.sandbox, 
                        'bg-warning text-dark': configuracion.sandbox
                      }"
                    >
                      <i class="mdi me-1" :class="configuracion.sandbox ? 'mdi-flask-outline' : 'mdi-shield-check-outline'"></i>
                      {{configuracion.sandbox ? 'Prueba': 'Producción'}}
                    </span>
                  </label>
                  <input
                    class="form-control font-monospace"
                    ref="id_client"
                    :placeholder="tituloIdClient()"
                    v-show="!configuracion.sandbox"
                    v-model="configuracion.id_cliente"
                  />
                  <input
                    class="form-control font-monospace"
                    ref="sandbox_id_cliente"
                    :placeholder="tituloIdClient()+' (Prueba)'"
                    v-show="configuracion.sandbox"
                    v-model="configuracion.sandbox_id_cliente"
                  />
                </div>
                <div class="col-md-6">
                  <label class="fw-semibold font-size-13 mb-1 d-flex align-items-center justify-content-between">
                    <span>{{ tituloSecret() }}</span>
                    <span
                      class="badge font-size-11"
                      :class="{
                        'bg-success': !configuracion.sandbox, 
                        'bg-warning text-dark': configuracion.sandbox
                      }"
                    >
                      <i class="mdi me-1" :class="configuracion.sandbox ? 'mdi-flask-outline' : 'mdi-shield-check-outline'"></i>
                      {{configuracion.sandbox ? 'Prueba': 'Producción'}}
                    </span>
                  </label>
                  <div class="input-group">
                    <input
                      class="form-control font-monospace"
                      name="clave"
                      :placeholder="mostrar_secret ? 'Password' : '*************'"
                      v-if="!configuracion.sandbox"
                      :type="mostrar_secret ? 'text' : 'password'"
                      v-model="configuracion.secret_cliente"
                    />
                    <input
                      class="form-control font-monospace"
                      name="clave"
                      :placeholder="mostrar_secret ? 'Password (Prueba)' : '************* (Prueba)'"
                      v-if="configuracion.sandbox"
                      :type="mostrar_secret ? 'text' : 'password'"
                      v-model="configuracion.sandbox_secret_cliente"
                    />
                    <button
                      class="btn"
                      :class="mostrar_secret ? 'btn-success' : 'btn-primary'"
                      type="button"
                      title="Mostrar/Ocultar Credencial"
                      @click="mostrar_secret = !mostrar_secret"
                    >
                      <i
                        class="mdi"
                        :class="{
                          'mdi-eye': mostrar_secret,
                          'mdi-eye-off': !mostrar_secret
                        }"
                      ></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <hr style="margin-top: 1.25rem; margin-bottom: 1.25rem;">

            <!-- Moneda y Comisión -->
            <div class="row align-items-center">
              <div class="col-md-6">
                <label class="fw-semibold font-size-13 mb-1">Moneda</label>
                <select class="form-select" v-model="configuracion.id_moneda">
                  <option :value="null">Seleccionar</option>
                  <option 
                    :style="!moneda.soportada ? 'color: red;': ''"
                    v-for="moneda in monedas_soportadas"
                    :value="moneda.id"
                    :key="'moneda-'+moneda.id"
                  >
                    ({{moneda.codigo}}) - {{moneda.nombre}} {{!moneda.soportada ? '** Moneda no soportada **': ''}}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="fw-semibold font-size-13 mb-1">Cobrar comisión</label>
                <div class="form-check form-switch form-switch-lg mb-0 mt-1">
                  <input
                    :checked="configuracion.comision"
                    @change="configuracion.comision = !configuracion.comision"
                    class="form-check-input style-pointer"
                    type="checkbox"
                    id="comision"
                  />
                  <label class="form-check-label" for="comision"></label>
                </div>
              </div>
            </div>

            <div class="row mt-3 p-3 bg-light rounded border mx-0" v-show="configuracion.comision">
              <div class="col-md-6 mb-2">
                <label class="fw-semibold font-size-13 mb-1">Porcentaje de comisión</label>
                <div class="input-group">
                  <input
                    class="form-control"
                    ref="porcentaje_comision"
                    placeholder="5.40"
                    min="0"
                    step="0.25"
                    max="100"
                    type="number"
                    onkeypress="if(event.keyCode < 46 || event.keyCode > 57 || event.keyCode == 47) event.returnValue = false;"
                    v-model="configuracion.porcentaje_comision"
                  />
                  <span class="input-group-text" :class="$store.state.layout.layoutMode == 'dark' ? '' : 'bg-white'">%</span>
                </div>
              </div>
              <div class="col-md-6 mb-2">
                <label class="fw-semibold font-size-13 mb-1">Adicional a la comisión</label>
                <div class="input-group">
                  <span class="input-group-text" :class="$store.state.layout.layoutMode == 'dark' ? '' : 'bg-white'">
                    {{moneda_seleccionada ? moneda_seleccionada.simbolo : ''}}
                  </span>
                  <input
                    class="form-control"
                    ref="adicional_comision"
                    placeholder="0.30"
                    min="0"
                    max="100"
                    type="number"
                    onkeypress="if(event.keyCode < 46 || event.keyCode > 57 || event.keyCode == 47) event.returnValue = false;"
                    v-model="configuracion.adicional_comision"
                  />
                  <span class="input-group-text" :class="$store.state.layout.layoutMode == 'dark' ? '' : 'bg-white'">
                    {{moneda_seleccionada ? moneda_seleccionada.codigo : ''}}
                  </span>
                </div>
              </div>
              <div class="col-md-6 mb-2" v-if="pasarela.id == 2">
                <label class="fw-semibold font-size-13 mb-1">Impuesto comisión</label>
                <div class="input-group">
                  <input
                    class="form-control"
                    ref="impuesto_comision"
                    placeholder="0.30"
                    min="0"
                    max="100"
                    step="0.25"
                    type="number"
                    onkeypress="if(event.keyCode < 46 || event.keyCode > 57 || event.keyCode == 47) event.returnValue = false;"
                    v-model="configuracion.porcentaje_impuesto_comision"
                  />
                  <span class="input-group-text bg-white">%</span>
                </div>
              </div>

              <!-- Vista previa de cálculo de comisión -->
              <div class="col-12 mt-2 pt-2 border-top">
                <small class="text-muted font-size-12">
                  <i class="mdi mdi-calculator text-primary me-1"></i>
                  Ejemplo (Monto: 100 {{ moneda_seleccionada ? moneda_seleccionada.codigo : 'USD' }}):
                  Cobro total = <strong>{{ calcularEjemploComision() }} {{ moneda_seleccionada ? moneda_seleccionada.codigo : '' }}</strong>
                </small>
              </div>
            </div>

            <hr style="margin-top: 1.25rem; margin-bottom: 1.25rem;">

            <!-- IPN Configuration section -->
            <div class="p-3 bg-light rounded border">
              <h6 class="mb-2 fw-bold font-size-14">
                Pasarela de pagos
                (<a href="https://miserviciodeinternet.com" target="_blank" rel="noopener noreferrer">
                  https://miserviciodeinternet.com
                </a>)
              </h6>
              <p class="font-size-13 text-muted mb-2">
                Para activar correctamente el <strong>IPN</strong> de la pasarela de pago <strong>{{ pasarela.id != null ? '('+pasarela.nombre+')': '' }}</strong>, dar de alta la siguiente ruta en la sección de IPN de su cuenta principal:
              </p>
              <div class="input-group">
                <span class="form-control text-primary font-monospace">
                  {{ pasarela.nombre_ruta_ipn }}
                </span>
                <button
                  class="btn"
                  :class="copiado_ipn ? 'btn-success' : 'btn-primary'"
                  type="button"
                  title="Copiar la ruta para el IPN"
                  @click="copiar"
                >
                  <i class="mdi me-1" :class="copiado_ipn ? 'mdi-check-all' : 'mdi-content-copy'"></i>
                  {{ copiado_ipn ? '¡Copiado!' : 'Copiar' }}
                </button>
              </div>
            </div>

          </div>
        </div>
        <div class="text-right pb-4">
          <div class="btn-group">
            <button class="btn btn-secondary"
              @click="$router.go(-1)">
              <i class="mdi mdi-chevron-left"></i>
              Atras
            </button>
            <button class="btn btn-success" @click="guardar()" :disabled="bandera_spinner">
              <i
                class="mdi"
                :class="!bandera_spinner ? 'mdi-content-save' : 'mdi-concourse-ci mdi-spin'"
              ></i>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main'
import PasarelaPagoSrv from '@/services/PasarelaPagoSrv'
import MonedaSoportadaPasarelaPagoSrv from '@/services/MonedaSoportadaPasarelaPagoSrv.js'

export default {
  name: 'EdicionPasarela',
  components: { Layout },
  data: function() {
    return {
      idPasarela: null,
      pasarela: {
        id: null,
        nombre: '',
        default_id_moneda: 4,
        default_porcentaje_comision: 5,
        default_adicional_comision: 5,
        default_porcentaje_impuesto_comision: 5,
        nombre_ruta_ipn: null,
      },
      configuracion: {
        id_pasarela: null,
        activa: 0,
        id_cliente: null,
        secret_cliente: null,
        id_moneda: null,
        comision: 0,
        porcentaje_comision: 0,
        adicional_comision: 0,
        porcentaje_impuesto_comision: 0,
        sandbox: 0,
        sandbox_id_cliente: null,
        sandbox_secret_cliente: null
      },
      monedas_soportadas: [],
      mostrar_secret: false,
      copiado_ipn: false,
      bandera_spinner: false
    }
  },
  computed: {
    moneda_seleccionada() {
      let moneda = this.monedas_soportadas.find(mnd => {
        return mnd.id == this.configuracion.id_moneda
      })

      return moneda
    }
  },
  created: function() {
    var self = this 

    self.idPasarela = this.$route.params.id

    self.cargarPasarela()
  },
  methods: {
    calcularEjemploComision() {
      let base = 100
      let porc = parseFloat(this.configuracion.porcentaje_comision) || 0
      let adic = parseFloat(this.configuracion.adicional_comision) || 0
      let imp = this.pasarela.id == 2 ? (parseFloat(this.configuracion.porcentaje_impuesto_comision) || 0) : 0
      let total = base + (base * (porc / 100)) + adic + (base * (imp / 100))
      return total.toFixed(2)
    },
    cargarPasarela: function() {
      var self = this

      PasarelaPagoSrv.pasarelaJSON(self.idPasarela).then(response => {
        self.pasarela = response.data
        self.cargarMonedasSoportadas(function() {
          self.cargarConfiguracionPasarela()
        })
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo cargar la pasarela'
        iu.msg.error(mensaje)
        console.log(error)
      })
    },
    cargarConfiguracionDefault:function() {
      var self = this

      self.configuracion.id_moneda = self.pasarela.default_id_moneda
      self.configuracion.porcentaje_comision = self.pasarela.default_porcentaje_comision
      self.configuracion.adicional_comision = self.pasarela.default_adicional_comision
      self.configuracion.porcentaje_impuesto_comision = self.pasarela.default_porcentaje_impuesto_comision
    },
    cargarConfiguracionPasarela: function() {
      var self = this

      PasarelaPagoSrv.configuracionJSON(this.idPasarela).then(response => {
        self.configuracion = response.data

        let index = this.monedas_soportadas.findIndex(m => {
          return m.id == self.configuracion.id_moneda
        })

        if(index == -1 && self.configuracion.id_moneda != null) self.cargarMonedaFaltante(self.configuracion.id_moneda)
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo cargar la configuración de la pasarela'
        let code = error?.response?.data?.codigo || null

        if(code == 404) {
          self.cargarConfiguracionDefault()
        } else {
          iu.msg.error(mensaje)
          console.log(error)
        }
      })
    },
    cargarMonedaFaltante:function(idMoneda) {
      var self = this

      MonedaSoportadaPasarelaPagoSrv.monedaJSON(idMoneda).then(response => {
        let moneda = response.data
        moneda.soportada = false

        self.monedas_soportadas.push(moneda)
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo cargar las moneda faltante'
        iu.msg.error(mensaje)
        console.log(error)
      })
    },
    cargarMonedasSoportadas: function(callback) {
      var self = this,
        params =  {
          id_pasarela: self.idPasarela
        }

      MonedaSoportadaPasarelaPagoSrv.monedasJSON(params).then(response => {
        self.monedas_soportadas = response.data

        self.monedas_soportadas.forEach(m => {
          m.soportada = true
        })
        
        if(callback) callback()
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo cargar las monedas soportadas para la pasarela de pagos'
        iu.msg.error(mensaje)
        console.log(error)
      })
    },
    cerrar: function() {
      this.$router.go(-1)
    },
    copiar() {
      var self = this
      if (!self.pasarela.nombre_ruta_ipn) return

      var aux = document.createElement("input");
      aux.setAttribute("value", self.pasarela.nombre_ruta_ipn);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);

      self.copiado_ipn = true
      setTimeout(() => {
        self.copiado_ipn = false
      }, 2000)

      iu.msg.success('La ruta para el IPN de la pasarela de pagos '+self.pasarela.nombre+' se ha copiado correctamente.')
    },
    guardar: function() {
      var self = this 

      if(self.configuracion.comision == true && (self.configuracion.porcentaje_comision === '' || self.configuracion.porcentaje_comision === null)){
        iu.msg.warning('No puede ir vacío el campo porcentaje de comisión')
        self.$refs.porcentaje_comision.select()
        return
      }

      if(self.configuracion.comision == true && (self.configuracion.adicional_comision === '' || self.configuracion.adicional_comision === null)){
        iu.msg.warning('No puede ir vacío el campo adicional a la comisión')
        self.$refs.adicional_comision.select()
        return
      }

      if(self.pasarela.id == 2 && self.configuracion.comision == true && (self.configuracion.porcentaje_impuesto_comision === '' || self.configuracion.porcentaje_impuesto_comision === null)){
        iu.msg.warning('No puede ir vacío el porcentaje de impuesto a la comisión')
        self.$refs.impuesto_comision.select()
        return
      }

      let config = {
        id_pasarela: self.pasarela.id,
        activa: self.configuracion.activa,
        id_cliente: self.configuracion.id_cliente,
        secret_cliente: self.configuracion.secret_cliente,
        id_moneda: self.configuracion.id_moneda,
        comision: self.configuracion.comision,
        porcentaje_comision: self.configuracion.porcentaje_comision,
        adicional_comision: self.configuracion.adicional_comision,
        porcentaje_impuesto_comision: self.configuracion.porcentaje_impuesto_comision,
        sandbox: self.configuracion.sandbox,
        sandbox_id_cliente: self.configuracion.sandbox_id_cliente,
        sandbox_secret_cliente: self.configuracion.sandbox_secret_cliente
      }

      self.bandera_spinner = true

      PasarelaPagoSrv.guardarConfiguracion(self.pasarela.id, config).then(response => {
        iu.msg.success("Se actualizaron correctamente los datos de la pasarela de pagos")
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudo guardar la configuración de la pasarela'
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        self.bandera_spinner = false
      })
    },
    mensajeModoPruebas(){
      var self = this 

      if(self.configuracion.sandbox)
        iu.msg.info("En modo prueba, los pagos y operaciones no tienen costo son ficticios. ", {
          position: `top-right`,
          duration: 4000,
          dismissible: true,
          pauseOnHover: true,
          useDefaultCss: true
        })
      else
        iu.msg.info("Advertencia a partir de este momento, los pagos y operaciones serán aplicados.",{
          position: `top-right`,
          duration: 4000,
          dismissible: true,
          pauseOnHover: true,
          useDefaultCss: true
        })
    },
    mensajePasarelaActiva(){
      var self = this 

      if(self.configuracion.activa)
        iu.msg.info("La pasarela "+self.pasarela.nombre+ ", se encuentra activa en mi servicio de internet.", {
          position: `top-right`,
          duration: 4000,
          dismissible: true,
          pauseOnHover: true,
          useDefaultCss: true
        })
      else
        iu.msg.info("La pasarela "+self.pasarela.nombre+ ", se encuentra inactiva en mi servicio de internet.", {
          position: `top-right`,
          duration: 4000,
          dismissible: true,
          pauseOnHover: true,
          useDefaultCss: true
        })
    },
    tituloIdClient() {
      var self = this 

      switch(self.pasarela.nombre) {
        case 'PayPal':
          return 'Client ID'
        break;
        case 'Mercado Pago':
          return 'Public Key'
        break;
        default:
          return 'Client ID'
        break;
      }
    },
    tituloSecret() {
      var self = this 

      switch(self.pasarela.nombre) {
        case 'PayPal':
          return 'Secret'
        break;
        case 'Mercado Pago':
          return 'Access Token'
        break;
        default:
          return 'Secret'
        break;
      }
    }
  }
}
</script>